module.exports = function(ejs) {
var __t, __p = '';
__p += '<div class="ggs-gallery-header__wrapper" roe-show-emitter=":: $ctrl.ggsProperties.key2emitter.allow_header" roe-show="$ctrl.ggsProperties.allow_header"><div class="ggs-gallery-header__cover-background" ng-if="' +
((__t = ( ejs.LE?'':'::' )) == null ? '' : __t) +
' $ctrl.hasCover()"><div class="ggs-gallery-header__cover-solid-background-placeholder" ng-if="' +
((__t = ( ejs.LE?'':'::' )) == null ? '' : __t) +
' $ctrl.hasCoverSolidBackground()" roe-style="{ height: $ctrl.getCoverColorSolidHeight() }" roe-style-emitter=":: $ctrl.getCoverColorSolidHeight"></div><div class="ggs-gallery-header__cover-gradient-background-placeholder" ng-if="' +
((__t = ( ejs.LE?'':'::' )) == null ? '' : __t) +
' $ctrl.hasCoverGradientBackground()" roe-style="{ height: $ctrl.getCoverColorGradientHeight() }" roe-style-emitter=":: $ctrl.getCoverColorGradientHeight"></div><div class="ggs-gallery-header__cover-full-image-placeholder" ng-if="' +
((__t = ( ejs.LE?'':'::' )) == null ? '' : __t) +
' $ctrl.hasCoverFullImage()" ng-show="' +
((__t = ( ejs.LE?'':'::' )) == null ? '' : __t) +
' !$ctrl.hasCoverImageSrc()" roe-style-emitter=":: $ctrl.contentHeightEmitter" roe-style="{ height: $ctrl.contentHeight }"></div><div class="ggs-gallery-header__cover-clipped-image" ng-if="' +
((__t = ( ejs.LE?'':'::' )) == null ? '' : __t) +
' $ctrl.hasCoverClippedImage()" ggs-background-image="' +
((__t = ( ejs.LE?'':'::' )) == null ? '' : __t) +
' $ctrl.getCoverImageSrc()" roe-style="{ height: $ctrl.getCoverImageClippedHeight() }" roe-style-emitter=":: $ctrl.getCoverImageClippedHeight"></div><img class="ggs-gallery-header__cover-full-image" ng-if="' +
((__t = ( ejs.LE?'':'::' )) == null ? '' : __t) +
' $ctrl.hasCoverFullImage()" ng-show="' +
((__t = ( ejs.LE?'':'::' )) == null ? '' : __t) +
' $ctrl.hasCoverImageSrc()" ggs-src="' +
((__t = ( ejs.LE?'':'::' )) == null ? '' : __t) +
' $ctrl.getCoverImageSrc()"></div><div class="ggs-gallery-header__content-wrapper"><div class="ggs-gallery-header__content" ggs-element-query="$ctrl.contentHeight = height" ggs-element-query-emitter=":: $ctrl.contentHeightEmitter"><div class="ggs-gallery-header__logo-wrapper" ng-show="' +
((__t = ( ejs.LE?'':'::' )) == null ? '' : __t) +
' $ctrl.hasLogo()" ng-class="' +
((__t = ( ejs.LE?'':'::' )) == null ? '' : __t) +
' {\n          \'ggs-gallery-header__logo-wrapper_divided\': $ctrl.hasCover()\n        }"><div class="ggs-gallery-header__logo ggs-gallery-header__logo-with-stroke" ng-show="' +
((__t = ( ejs.LE?'':'::' )) == null ? '' : __t) +
' $ctrl.ggsProperties.logo_stroke"></div><img class="ggs-gallery-header__logo ggs-gallery-header__logo-without-stroke" ng-hide="' +
((__t = ( ejs.LE?'':'::' )) == null ? '' : __t) +
' $ctrl.ggsProperties.logo_stroke" ggs-src="' +
((__t = ( ejs.LE?'':'::' )) == null ? '' : __t) +
' $ctrl.ggsProperties.logo"></div><div class="ggs-gallery-header__text-wrapper"><div class="ggs-gallery-header__name" ng-if="' +
((__t = ( ejs.LE?'':'::' )) == null ? '' : __t) +
' $ctrl.hasName()" ng-bind-html="' +
((__t = ( ejs.LE?'':'::' )) == null ? '' : __t) +
' $ctrl.getNameText()"></div><div class="ggs-gallery-header__desc" ng-if="' +
((__t = ( ejs.LE?'':'::' )) == null ? '' : __t) +
' $ctrl.hasDesc()" ng-bind-html="' +
((__t = ( ejs.LE?'':'::' )) == null ? '' : __t) +
' $ctrl.getDescText()"></div></div><div class="ggs-gallery-header__social-block" ng-if="' +
((__t = ( ejs.LE?'':'::' )) == null ? '' : __t) +
' $ctrl.hasSomeSocialUrls()"><a class="ggs-gallery-header__social-icon ggs-clr__facebook" ng-if="' +
((__t = ( ejs.LE?'':'::' )) == null ? '' : __t) +
' $ctrl.ggsProperties.facebook_url" ggs-href="' +
((__t = ( ejs.LE?'':'::' )) == null ? '' : __t) +
' $ctrl.ggsProperties.facebook_url"><div class="ggs-fa ggs-fa-facebook"></div></a><a class="ggs-gallery-header__social-icon ggs-clr__twitter" ng-if="' +
((__t = ( ejs.LE?'':'::' )) == null ? '' : __t) +
' $ctrl.ggsProperties.twitter_url" ggs-href="' +
((__t = ( ejs.LE?'':'::' )) == null ? '' : __t) +
' $ctrl.ggsProperties.twitter_url"><div class="ggs-fa ggs-fa-x-twitter"></div></a><a class="ggs-gallery-header__social-icon ggs-clr__instagram" ng-if="' +
((__t = ( ejs.LE?'':'::' )) == null ? '' : __t) +
' $ctrl.ggsProperties.instagram_url" ggs-href="' +
((__t = ( ejs.LE?'':'::' )) == null ? '' : __t) +
' $ctrl.ggsProperties.instagram_url"><div class="ggs-fa ggs-fa-instagram"></div></a><a class="ggs-gallery-header__social-icon ggs-clr__tiktok" ng-if="' +
((__t = ( ejs.LE?'':'::' )) == null ? '' : __t) +
' $ctrl.ggsProperties.tiktok_url" ggs-href="' +
((__t = ( ejs.LE?'':'::' )) == null ? '' : __t) +
' $ctrl.ggsProperties.tiktok_url"><div class="ggs-fa ggs-fa-tiktok"></div></a><a class="ggs-gallery-header__social-icon ggs-clr__tumblr" ng-if="' +
((__t = ( ejs.LE?'':'::' )) == null ? '' : __t) +
' $ctrl.ggsProperties.tumblr_url" ggs-href="' +
((__t = ( ejs.LE?'':'::' )) == null ? '' : __t) +
' $ctrl.ggsProperties.tumblr_url"><div class="ggs-fa ggs-fa-tumblr"></div></a><a class="ggs-gallery-header__social-icon ggs-clr__youtube" ng-if="' +
((__t = ( ejs.LE?'':'::' )) == null ? '' : __t) +
' $ctrl.ggsProperties.youtube_url" ggs-href="' +
((__t = ( ejs.LE?'':'::' )) == null ? '' : __t) +
' $ctrl.ggsProperties.youtube_url"><div class="ggs-fa ggs-fa-youtube-play"></div></a><a class="ggs-gallery-header__social-icon ggs-clr__soundcloud" ng-if="' +
((__t = ( ejs.LE?'':'::' )) == null ? '' : __t) +
' $ctrl.ggsProperties.soundcloud_url" ggs-href="' +
((__t = ( ejs.LE?'':'::' )) == null ? '' : __t) +
' $ctrl.ggsProperties.soundcloud_url"><div class="ggs-fa ggs-fa-soundcloud"></div></a><a class="ggs-gallery-header__social-icon ggs-clr__pinterest" ng-if="' +
((__t = ( ejs.LE?'':'::' )) == null ? '' : __t) +
' $ctrl.ggsProperties.pinterest_url" ggs-href="' +
((__t = ( ejs.LE?'':'::' )) == null ? '' : __t) +
' $ctrl.ggsProperties.pinterest_url"><div class="ggs-fa ggs-fa-pinterest"></div></a><a class="ggs-gallery-header__social-icon ggs-clr__globe" ng-if="' +
((__t = ( ejs.LE?'':'::' )) == null ? '' : __t) +
' $ctrl.ggsProperties.website_url" ggs-href="' +
((__t = ( ejs.LE?'':'::' )) == null ? '' : __t) +
' $ctrl.ggsProperties.website_url"><div class="ggs-fa ggs-fa-globe"></div></a></div></div></div></div>';
return __p
}